const authorCollections = [
  {
    id: 1,
    name: 'Doodles',
    address: '0x8a90cab2b38dba80c64b7734e58ee1db38b8992e',
    img: 'https://lh3.googleusercontent.com/7B0qai02OdHA8P_EOVK672qUliyjQdQDGNrACxs7WnTgZAkJa_wWURnIFKeOh5VTf8cfTqW3wQpozGedaC9mteKphEOtztls02RlWQ=s130',
  },
  {
    id: 2,
    name: 'Slotie NFT',
    address: '0x5fdb2b0c56afa73b8ca2228e6ab92be90325961d',
    img: 'https://lh3.googleusercontent.com/FDfJqrobmHVsLC6tNvjYv90xxRUPqG39zJqpjj-FpgKJJX5n23IegiO4lkqbATXRUxz2z8GGHa8qMN0cHqof1hx2xetxy6MobmKxkw=s130',
  },
  {
    id: 3,
    name: 'BARFLIES',
    address: '0x47fb8da06eb96bcb04752388b456da28e56bad9f',
    img: 'https://lh3.googleusercontent.com/HbzSXtH1ki3GdMNVL14YQt3tVdU_nkqGmfKDBZ8sBvJfOwEZu1-_sYIGlkESq3xujG8ra2GAKI78PyAUR7PoeTeth1jsbk5qqTSFm88=s130',
  },
  {
    id: 4,
    name: 'Metabillionari',
    address: '0xc6c817cd60e17fed0af2a759624e02dd6c812e64',
    img: 'https://lh3.googleusercontent.com/-gAVcVJDwBscLyIJDN_1afv0sNwkW9_sOJmlFoSn83d_upnQdLQv-5hPgvNOdFoR-I4zkTunxnuxj9K_MmI8RjbsjXxPnBRMZ4vE=s130',
  },
  {
    id: 5,
    name: 'Robotos Official',
    address: '0x099689220846644f87d1137665cded7bf3422747',
    img: 'https://lh3.googleusercontent.com/5PO4I0APxP3xVDiOlSWewhb7iVf5Hnp5trQ22EVCAiKkSAnBTu0u1W6UgELpQtxr0LQz4rfNaScadZ4279naNCd6rXzewLIRrfEa=s130',
  },
  {
    id: 6,
    name: 'The Doge Pound',
    address: '0xf4ee95274741437636e748ddac70818b4ed7d043',
    img: 'https://lh3.googleusercontent.com/uNkBbVvg7wyRjspsooFtYYbRHFHFISntxwijLRskjGhplP8A3Iz_4ApLU_yLp9BW-Ai0yUWC50A138IGUkII55QWRT7g12qmSRTlbA=s130',
  },
  {
    id: 7,
    name: 'ThorGuards',
    address: '0xa98b29a8f5a247802149c268ecf860b8308b7291',
    img: 'https://lh3.googleusercontent.com/IEJU8udH96KbKM-kdjFqDy3jHV4Hsx7T2sd_PgW3mrVR4LHTQlH7fx8MoSWRV5fNhOHJ-EQFG6BxzEHzm2-EjUjohoOUUrPaFqTAzSM=w128',
  },
  {
    id: 8,
    name: 'Meka Ape Club',
    address: '0x977dc06b51e14277a5ac047b44c78dbcc60a372b',
    img: 'https://lh3.googleusercontent.com/Mdt0uE09V6i_9q61cjUk8E_bjP1o8iOegImxP9yNzelOKUkQNmftsrnW1rALFOx_NzEHpKsIyN4JB-Rb9-QBDJSrVAXMmHBPKKrKrQ=s130',
  },

  {
    id: 9,
    name: 'CloneX',
    address: '0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b',
    img: 'https://lh3.googleusercontent.com/XN0XuD8Uh3jyRWNtPTFeXJg_ht8m5ofDx6aHklOiy4amhFuWUa0JaR6It49AH8tlnYS386Q0TW_-Lmedn0UET_ko1a3CbJGeu5iHMg=w128',
  },

  {
    id: 10,
    name: 'Mutant Ape Yacht Club',
    address: '0x60e4d786628fea6478f785a6d7e704777c86a7c6',
    img: 'https://lh3.googleusercontent.com/lHexKRMpw-aoSyB1WdFBff5yfANLReFxHzt1DOj_sg7mS14yARpuvYcUtsyyx-Nkpk6WTcUPFoG53VnLJezYi8hAs0OxNZwlw6Y-dmI=w128',
  },
];

module.exports = authorCollections;
